const SUPPORTED_VENUE_ROLES = new Set(["OWNER", "EMPLOYEE"]);

const isMultiVenueEnabled = () => {
    const configured = process.env.REACT_APP_MULTI_VENUE_ENABLED;
    if (typeof configured === "string") {
        return configured.toLowerCase() === "true";
    }

    return process.env.REACT_APP_FIREBASE_PROJECT_ID === "tiply-app-test";
};

const normalizeVenueEntry = (businessID, entry = {}) => {
    const role = String(entry?.role || "").toUpperCase();
    if (!businessID || !SUPPORTED_VENUE_ROLES.has(role)) return null;
    if (role === "EMPLOYEE" && !entry?.employeeID) return null;

    return {
        businessID,
        role,
        employeeID: role === "EMPLOYEE" ? String(entry.employeeID) : null,
    };
};

const resolveVenueAccess = (rawUserData, multiVenueEnabled = isMultiVenueEnabled()) => {
    if (!rawUserData || rawUserData.role === "ADMIN") return [];

    const configuredAccess = rawUserData.venueAccess;
    const hasConfiguredAccess = multiVenueEnabled
        && configuredAccess
        && typeof configuredAccess === "object"
        && !Array.isArray(configuredAccess)
        && Object.keys(configuredAccess).length > 0;

    if (hasConfiguredAccess) {
        return Object.entries(configuredAccess)
            .map(([businessID, entry]) => normalizeVenueEntry(businessID, entry))
            .filter(Boolean)
            .sort((left, right) => left.businessID.localeCompare(right.businessID));
    }

    const legacyEntry = normalizeVenueEntry(rawUserData.businessID, {
        role: rawUserData.role,
        employeeID: rawUserData.employeeID,
    });

    return legacyEntry ? [legacyEntry] : [];
};

const effectiveUserDataForVenue = (rawUserData, activeVenue) => {
    if (!rawUserData) return null;
    if (rawUserData.role === "ADMIN" || !activeVenue) return rawUserData;

    return {
        ...rawUserData,
        businessID: activeVenue.businessID,
        role: activeVenue.role,
        employeeID: activeVenue.employeeID ?? null,
    };
};

const venueDashboardPath = (role) => {
    if (role === "OWNER") return "/business/dashboard";
    if (role === "EMPLOYEE") return "/profile/dashboard";
    if (role === "ADMIN") return "/admin";
    return "/login";
};

const venueSessionKey = (uid) => `tiply.activeVenue.${uid}`;

module.exports = {
    effectiveUserDataForVenue,
    isMultiVenueEnabled,
    resolveVenueAccess,
    venueDashboardPath,
    venueSessionKey,
};
